import React, { Component } from 'react';
import PropTypes from 'prop-types';

class InputField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        // Handle outside value change
        if (this.props.value !== nextProps.value) {
            this.setState({ value: nextProps.value })
        }
    }

    handleChange(e) {
        if (this.props.onChange) {
            this.props.onChange(e);
        }

        this.setState({value: e.target.value});
    }

    render() {
        const { type, label, className, name, id, required, disabled, placeholder, addonPre, addonPost, step, parentClassName } = this.props;

        return (
            <div className={`form-group form-group-default ${parentClassName} ${required ? 'required' : ''} ${addonPre || addonPost ? 'input-group' : ''}`}>
                {/* Addon Pre*/}
                {addonPre && (
                    <div className="input-group-prepend">
                        <span className="input-group-text">{addonPre}</span>
                    </div>
                )}

                {/* Field */}
                <div className="form-input-group">
                    <label>{label}</label>
                    <input type={type}
                           name={name}
                           id={id}
                           className={`form-control ${className}`}
                           value={this.state.value}
                           onChange={this.handleChange}
                           required={required}
                           placeholder={placeholder}
                           readOnly={disabled}
                           step={step}
                    />
                </div>

                {/* Addon Post */}
                {addonPost && (
                    <div className="input-group-append">
                        <span className="input-group-text">{addonPost}</span>
                    </div>
                )}
            </div>
        );
    }
}

InputField.propTypes = {
    type: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    addonPre: PropTypes.node,
    addonPost: PropTypes.node,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    step: PropTypes.string,
};

InputField.defaultProps = {
    type: 'string',
    value: '',
};

export default InputField;


// WEBPACK FOOTER //
// ./src/components/form/input-field.js